module.exports = __webpack_public_path__ + "img/icons_29.a2b4f5d1.svg";